import { derived } from "svelte/store";
import { userStore } from "./session";
import { location as spaLocation } from "svelte-spa-router";

const manageVendorsHeader = (active) => ({ name: "header_vendors", url: "/vendors", active });
const manageRatesHeader = (active) => ({ name: "header_rates", url: "/rates", active });
const manageLogosHeader = (active) => ({ name: "header_logo", url: "/logos", active});
const manageLibraryHeader = (active) => ({ name: "header_library", url: "/library", active});
const manageColorShcemesHeader = active => ({ name: "header_colorSchemes", url: "/colorSchemes", active });

const settingsHeaderLinksStore = derived(userStore, async ($user, set) => {
    spaLocation.subscribe(location => {
        const headers = [];
        if ($user.getAcl('manageUsers')) {
            headers.push(manageVendorsHeader(location === '/vendors'));
        }
        if ($user.getAcl('manageRate')) {
            headers.push(manageRatesHeader(location === '/rates'));
        }
        if ($user.getAcl('reportLogo') || $user.getAcl('appLogo')) {
            headers.push(manageLogosHeader(location === '/logos'));
        }
        if ($user.getAcl('libraryEdit')) {
            headers.push(manageLibraryHeader(location === '/library'));
        }
        if ($user.getAcl('appColors') || $user.getAcl('reportColors')) {
            headers.push(manageColorShcemesHeader(location === '/colorSchemes'));
        }
        set(headers);
    });
});

export { settingsHeaderLinksStore }
